import React from 'react';
import { Col, Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { WorkstationSelect } from '@/components/ui/Inputs/WorkstationSelect';
import { useApplicationContext } from '@/context/v1/Application/context';
import { useWorkstations } from '@/hooks/v1';

const { useFormInstance, useWatch } = Form;

export function Workstations() {
	const form = useFormInstance();
	const { organization, company } = useApplicationContext();

	const lineId = useWatch('line_id', form);
	const workstationId = useWatch('workstation_id', form);

	const {
		data: workstations,
		isLoading,
		isFetching,
		isError
	} = useWorkstations({
		organization_id: organization?.id,
		company_id: company?.id,
		line_id: lineId
	});

	function handleWorkstationSelect(id: string): void {
		form.setFieldValue(['workstation_id'], id);
	}

	function handleClearWorkstations(): void {
		form.setFieldValue(['workstation_id'], undefined);
	}

	return (
		<Col xs={24}>
			<Form.Item name={['workstation_id']} label={I18n.get('Workstation')} labelCol={{ span: 24 }}>
				<WorkstationSelect
					lineId={lineId}
					loading={isFetching}
					allowCreation={false}
					fieldName="workstation_id"
					workstations={workstations}
					workstationId={workstationId}
					handleSelectWorkstation={handleWorkstationSelect}
					handleClearWorkstations={handleClearWorkstations}
					disabled={isLoading || isFetching || isError || !lineId}
				/>
			</Form.Item>
		</Col>
	);
}
